var map = {
	"./naturalCircle0h.svg": "CHCy",
	"./naturalCircle1h.svg": "MTxG",
	"./naturalCircle2h.svg": "v2HR",
	"./naturalCircle3h.svg": "q5iq",
	"./naturalCircle4h.svg": "yrAg",
	"./naturalCircle5h.svg": "Rkro",
	"./naturalCircle6h.svg": "NugD",
	"./naturalCircle7h.svg": "r8YB",
	"./naturalCircle8h.svg": "hAWz",
	"./naturalCircle9h.svg": "/y86"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "oddM";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/naturalCircle.*h\.svg$
// module id = oddM
// module chunks = 1